import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { LanguageService } from '../../../../shared/services/language.service';
import { DocumentCardService } from '../../_api/services/document-card.service';
import { DocumentCard } from "../../_api/models/document-card.model";

import { Subject } from "rxjs";
import { DocumentVersion } from "../../_api/models/document-version.model";
import { DocumentsComponent } from '../../document-queue/documents/documents.component';
import { DxAccordionComponent } from 'devextreme-angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentTag } from '../../_api/models/document-tag.model';
import { ConfigService } from '../../../../shared/services/config.service';
import { DocumentAdminService } from '../../_api/services/document-admin.service';
import { faWindowMaximize } from '@fortawesome/free-solid-svg-icons';
import { UserService } from '../../../../shared/services/user.service';
import notify from 'devextreme/ui/notify';

let self: DocumentOperatorDocumentCardComponent = null;

@Component({
  selector: 'app-document-operator-document-card',
  templateUrl: './document-operator-document-card.component.html',
  styleUrls: ['./document-operator-document-card.component.css']
})
export class DocumentOperatorDocumentCardComponent implements OnInit, AfterViewInit {

  private docId: number = null;
  @Input() set documentId(n: number) {
    this.docId = n;
    self.loadDocument();
  }
  get documentId(): number {
    return this.docId;
  }
  @Input() documentTypes: any;
  @Input() documentCategories: any;
  @Output() loading = new EventEmitter<boolean>();
  @Output() closeTab = new EventEmitter<any>();
  @Output() documentAdded = new EventEmitter<void>();

  document: DocumentCard = new DocumentCard;
  documentVersion: DocumentVersion = new DocumentVersion;
  documentTags: DocumentTag[];
  selectedItems: any[] = [];
  menuDataSource: any[];
  menuIndex: number;
  isMenuOpen = true;
  showPopUpAddVersion = false;
  latestVersionNumber = "0";
  saveDisabled: boolean = false;
  editingMode = 'cell';
  treeListHeight = "auto";
  codeTreeListHeight = "auto";
  selectedCodes: number[];
  accordionSelectedItems: any[];
  versionCountString: string;
  saveSubject: Subject<void> = new Subject<void>();
  fileurl: SafeResourceUrl;
  fileCounter: number;
  isFavorite = false;
  showPopUpImage = false;

  faWindowMaximize = faWindowMaximize;

  labels = {
    Details: this.languageService.LNG("Label.Details"),
    Versions: this.languageService.LNG("Label.Versions"),
    CodesAndAttributes: this.languageService.LNG("Label.CodesAndAttributes"),
    Preview: this.languageService.LNG("Label.Preview"),
    Discussion: this.languageService.LNG("Label.Discussion"),
    LastUpdated: this.languageService.LNG("Label.LastUpdated"),
    By: this.languageService.LNG("Label.By"),
    Number: this.languageService.LNG("Label.NumberNumber"),
    AddVersion: this.languageService.LNG("Label.Add") + " " + this.languageService.LNG("Label.Version"),
    Save: this.languageService.LNG("Label.Save"),
    AddNew: this.languageService.LNG("Label.Add"),
    Close: this.languageService.LNG('Label.Close'),
    Codes: this.languageService.LNG('Label.Codes'),
    Attributes: this.languageService.LNG('Label.Attributes'),
    MyFavorite: this.languageService.LNG('Label.Favourite')
  }

  @ViewChild(DocumentsComponent, { static: false }) documentsComponent: DocumentsComponent;
  @ViewChild(DxAccordionComponent) accordion: DxAccordionComponent;

  constructor(public languageService: LanguageService,
    private documentCardService: DocumentCardService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    private documentAdminService: DocumentAdminService,
    private userService: UserService) {
    self = this;
  }

  ngAfterViewInit(): void {
    self.accordianExpandAll();
  }

  async getDocumentTags() {
    self.documentTags = await self.documentAdminService.getTags().toPromise();
  }

  ngOnInit(): void {
    self.getDocumentTags();
    setTimeout(() => {
      self.menuDataSource = [
        { text: this.languageService.LNG('Label.Card'), },
        { text: this.languageService.LNG('Label.DocumentCardVersionFileList'), },
      ];
      self.menuIndex = 0;
      self.selectedItems = [self.menuDataSource[0]];
    }, 0);
    this.getUrl();
  }

  loadDocument() {
    if (self.documentId) {
      self.loading.emit(true);
      self.documentCardService.get(self.documentId)
        .subscribe((result: DocumentCard) => { // success path  
          self.document = result;
          self.documentVersion = result.CurrentDocumentVersion;
          self.setDocVersion(this.document);
          self.onFavorite(this.documentId).then(r => { });
          self.documentCardService.SetViewed(self.documentId).subscribe(r => { });

          self.loading.emit(false);
        }, error => {
        });
    } else {
      self.clear();
    }
  }

  async onFavorite(documentId: number) {
    self.isFavorite = await self.documentCardService.isFavorite(documentId).toPromise();
  }

  getUrl() {
    if (self.documentVersion.DocumentFiles.length > 0) {
      const theUrl = `${self.configService.config.documentUrl}/api/DocumentCard/PreviewFile/${self.documentVersion.DocumentFiles[self.documentVersion.DocumentFiles.length - 1].FileName}?documentFileId=${self.documentVersion.DocumentFiles[self.documentVersion.DocumentFiles.length - 1].DocumentFileId}&languageId=${this.userService.languageId}&SessionId=${this.userService.sessionId}`;
      self.fileurl = this.sanitizer.bypassSecurityTrustResourceUrl(theUrl);
    }
  }

  setDocVersion(document: any) {
    self.fileCounter = 1;
    self.documentVersion = self.document.CurrentDocumentVersion;
    self.getUrl();
  }

  setSelectedCodes(codes: any) {
    self.selectedCodes = codes.map(({ DocumentCodeId }) => DocumentCodeId);
    self.documentsComponent.selectedCodes = self.selectedCodes;
  }

  async favouriteClick() {
    await self.documentCardService.setFavorite(self.document.DocumentId, !self.isFavorite).toPromise();
    notify(this.languageService.LNG('Label.ServerUpdated'), "info", 2000);
  }

  accordianExpandAll() {
    for (let i = 0; i < self.accordion.items.length; i++) {
      self.accordion.instance.expandItem(i);
    }
  }

  onShowClicked() {
    self.showPopUpImage = true;
  }

  clear() {
    self.document = new DocumentCard();
  }

  onCloseTab() {
    self.closeTab.emit();
  }
}
